<template>
  <div>
    <vs-tabs v-if="tabList.length > 1" v-model="tabIndex">
      <vs-tab v-for="tab of tabList" :key="tab.name" :label="tab.label" @click="onClickTab(tab)" />
    </vs-tabs>

    <vs-card>
      <div class="p-4">
        <div class="flex justify-between">
          <span class="col-span-2 md:col-span-1" style="font-weight: 700; font-size: 18px;">작업자 회원 관리</span>
          <vs-button color="secondary" type="border" @click="onClickClose">닫기</vs-button>
        </div>

        <h5 class="my-4"><i class="dot"></i> 회원구분</h5>
        <div class="grid-container mb-8">
          <radio-group
            class="col-span-4 my-2"
            flex
            :items="registerTypeList"
            :row-count="2"
            v-model="pendingUser.meta.registerType"
          />
        </div>

        <h5 class="my-4"><i class="dot"></i> 작업자 정보</h5>
        <div class="grid-container">
          <input-form class="grid-item" label="현장명">
            <vs-select
              class="w-full"
              v-model="pendingUser.meta.field"
              :options="fieldOptions"
              autocomplete
              placeholder="현장을 선택해주세요.">
              <vs-select-item v-for="item in fieldOptions" :key="item.id" :value="item" :text="item.field_name" />
            </vs-select>
          </input-form>

          <input-form class="grid-item" label="소속 업체명(사업자등록번호)" :error-message="error.업체">
            <div v-if="pendingUser.meta.업체
            && pendingUser.meta.업체.id && pendingUser.meta.업체.id !== ''
            && pendingUser.meta.업체.com_name && pendingUser.meta.업체.com_name !== ''"
                 class="align-center" style="display: grid; grid-template-columns: 1fr 1fr auto; gap: 0.675rem; align-items: start;">
              <ml-input class="w-full" v-model="pendingUser.meta.업체.com_name" readonly />
              <ml-input class="w-full" v-model="pendingUser.meta.업체.com_number" :danger="isDanger업체" readonly />
              <vs-button class="input-button py-0 px-3" color="secondary" type="border" @click="popupSearchCompany = true">업체 변경</vs-button>
            </div>
            <label v-else class="w-full" style="display: grid; grid-template-columns: 1fr auto; gap: 0.675rem; align-items: start;">
              <ml-input
                class="w-full"
                v-model="pendingUser.meta.업체.com_name"
                :danger="isDanger업체"
                readonly
              />
              <vs-button class="input-button py-0 px-3" color="secondary" type="border" @click="popupSearchCompany = true">업체 검색</vs-button>
            </label>
          </input-form>
        </div>
        <div class="grid-container mt-4">
          <input-form class="grid-item" label="아이디">
            <label class="w-full" style="gap: 0.675rem;">
              <ml-input
                class="w-full"
                placeholder="아이디 입력"
                v-model="pendingUser.username"
                readonly
              />
            </label>
          </input-form>
          <input-form class="grid-item" label="비밀번호">
            <ml-input class="w-full" type="password" placeholder="********" readonly />
          </input-form>

          <input-form class="grid-item gap-2" label="내국인/외국인">
            <radio-group
              class="col-span-4 my-2"
              flex
              :items="[{label: '내국인', value: false}, {label: '외국인', value: true}]"
              :row-count="2"
              v-model="pendingUser.isForeigner"
              readonly
            />
          </input-form>

        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="이름">
            <ml-input class="w-full" v-model="pendingUser.name" readonly />
          </input-form>
          <input-form class="grid-item" :label="pendingUser.isForeigner? '외국인등록번호(앞 7자리 한정)':'주민등록번호(앞 7자리 한정)'">
            <ml-input class="w-full" v-model="formatRRN" readonly />
          </input-form>

          <input-form class="grid-item" label="휴대폰번호">
            <div class="flex gap-2">
              <ml-input class="w-full" v-model="pendingUser.phone1" :max="3" readonly />
              <span style="align-content: center;">-</span>
              <ml-input class="w-full" v-model="pendingUser.phone2" :max="4" readonly />
              <span style="align-content: center;">-</span>
              <ml-input class="w-full" v-model="pendingUser.phone3" :max="4" readonly />
            </div>
          </input-form>
          <input-form class="grid-item" label="이메일">
            <ml-input class="w-full" v-model="pendingUser.email" />
          </input-form>

<!--          <input-form class="grid-item" label="주소">-->
<!--            <address-field class="w-full" v-model="pendingUser.meta.address" :visible-zip-code="false" />-->
<!--          </input-form>-->
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="직종" :error-message="error.직종">
            <div :style="isDangerJobInput ? 'border: 1px solid #ff0000; border-radius: 6px;' : ''" >
              <vs-select
                class="w-full"
                v-model="pendingUser.meta.직종"
                :options="직종Options"
                autocomplete
                placeholder="직종을 선택해주세요."
              >
                <vs-select-item v-for="(item, itemIndex) in 직종Options" :key="`${item}_${itemIndex}`" :value="item" :text="item" />
              </vs-select>

              <ml-input
                v-if="pendingUser.meta.직종 === '직접입력'"
                class="w-full mt-2"
                v-model="pendingUser.meta.직종_직접입력"
              />

            </div>
          </input-form>
        </div>

        <div class="grid-container mt-4">
          <input-form class="grid-item" label="건설업기초안전교육">
            <file-uploader-none-token
              class="w-full"
              placeholder="파일을 업로드해주세요."
              v-model="pendingUser.meta.건설업기초안전교육" readonly/>
          </input-form>
        </div>

        <!-- 장비운전자 -->
        <h5 class="my-8 flex"><vs-checkbox v-model="pendingUser.meta.장비운전자"/> 장비운전자</h5>
        <div v-if="pendingUser.meta.장비운전자" class="grid-container mt-4">
          <div class="grid-item">
            <span>건설기계 조종사 면허</span>
            <ml-input class="my-1 w-full" v-model="pendingUser.meta.건설기계조종사면허번호" placeholder="지역00-1234-5678-90"/>
          </div>
          <div class="grid-item grid">
            <span>면허증 사진</span>
            <div class="h-full" style="width: 367px; min-height: 120px">
              <img :src="pendingUser.meta.enc.건설기계조종사면허증사진 && pendingUser.meta.enc.건설기계조종사면허증사진 !== '' ?
                           pendingUser.meta.enc.건설기계조종사면허증사진 : require(`@/assets/images/checker.svg`)" alt="" height="120" class="my-1"/>
            </div>

            <div>
              <span style="color: #ff0000; font-weight: 400;">
                ※ 주민등록번호 뒷자리는 가려서 촬영해주세요.<br/>(전체본 등록 시 가입이 반려됩니다.)
              </span>
            </div>
          </div>
        </div>

        <div v-if="pendingUser.meta.장비운전자" class="grid-container mt-4">
          <input-form class="grid-item" label="장비명" :error-message="error.장비명">
            <div class="" :style="isDangerEquipmentNameInput ? 'border: 1px solid #ff0000; border-radius: 6px;' : ''" >
              <vs-select
                class="w-full"
                v-model="pendingUser.meta.장비명"
                :options="장비명Options"
                autocomplete
                placeholder="장비명을 선택해주세요."
                @change="onEquipmentNameChange"
              >
                <vs-select-item v-for="(item, itemIndex) in 장비명Options" :key="`${item}_${itemIndex}`" :value="item" :text="item" />
              </vs-select>

              <ml-input
                v-if="pendingUser.meta.장비명 === '직접입력'"
                class="w-full mt-2"
                v-model="pendingUser.meta.장비명_직접입력"
              />

            </div>
          </input-form>

          <input-form class="grid-item" label="규격" :error-message="error.장비규격">
            <div class="" :style="isDangerEquipmentSizeInput ? 'border: 1px solid #ff0000; border-radius: 6px;' : ''" >
              <vs-select
                class="w-full"
                v-model="pendingUser.meta.장비규격"
                autocomplete
                placeholder="규격을 선택해주세요."
              >
                <vs-select-item v-for="(item, itemIndex) in 장비규격Options" :key="`${item}_${itemIndex}`" :value="item" :text="item" />
              </vs-select>

              <ml-input
                v-if="pendingUser.meta.장비규격 === '직접입력'"
                class="w-full mt-2"
                v-model="pendingUser.meta.장비규격_직접입력"
              />

            </div>
          </input-form>
        </div>

        <div v-if="pendingUser.meta.장비운전자" class="grid-container mt-4">
          <input-form class="col-span-4" label="장비번호">
            <ml-input
              class="w-full"
              placeholder="장비번호를 입력해주세요."
              v-model="pendingUser.meta.장비번호"
            />
          </input-form>
        </div>

      </div>

      <div v-if="editMode" class="flex mt-8 gap-6 justify-center">
        <vs-button color="#AEB1B6" type="filled" style="min-width: 254px;" @click="onClickCancel">취소</vs-button>
        <vs-button color="secondary" style="min-width: 254px;" @click="onClickSave">저장</vs-button>
      </div>
      <div v-else-if="!editMode && myInfo && (myInfo.can_manage_pending_user || myInfo.is_superuser)" class="flex mt-8 gap-6 justify-center">
        <vs-button color="#EA5455" type="filled" style="width: 254px;" @click="popupRejectJoin = true">회원가입 거절</vs-button>
        <vs-button color="#28C76F" type="filled" style="width: 254px;" @click="onClickJoinAccount">회원가입 승인</vs-button>
      </div>

    </vs-card>

    <popup-search-company
      ref="popupSearchCompany"
      v-model="popupSearchCompany"
      @handleClickSelect="handleClickSelectCompany"
    />
    <popup-reject-join-account v-model="popupRejectJoin" @reject="onClickRejectJoinAccount"/>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import HttpRequest from "@/util/HttpRequest";
import FileUploader from "@/components/FileUploader.vue";
import SignField from "@/components/SignField.vue";
import FileUploaderNoneToken from "@/components/FileUploaderNoneToken.vue";
import AddressField from "@/components/AddressField.vue";
import InputForm from "@/views/pages/register/InputForm.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PopupCompanyInfo from "@/views/pages/standing-account/PopupCompanyInfo.vue";
import PopupRejectJoinAccount from "@/views/pages/standing-account/PopupRejectJoinAccount.vue";
import PopupSearchCompany from "@/popup/PopupSearchCompany.vue";
import {registerTypeList} from "@/views/pages/register/RegisterTypeInfo.js";
import {occupation} from "@/util/OccupationUtil";
import {equipmentName, getEquipmentSizeByKey} from "@/util/equipmentUtil";

export default {
  components: {
    PopupSearchCompany,
    PopupRejectJoinAccount,
    PopupCompanyInfo,
    RadioGroup,
    InputForm,
    AddressField,
    FileUploaderNoneToken,
    SignField,
    FileUploader,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  computed:{
    myInfo () {
      return this.$store.state.auth.userInfo
    },

    tabList() {
      const list = [
        { code: 0, name: "page-standing-account-list", label: "회원가입 대기 목록", },
        { code: 1, name: "page-confirm-account-list", label: "회원가입 승인 목록", }
      ];
      return list;
    },

    getId () {
      return this.$route.params.id
    },

    formatRRN: {
      get() {
        const rrn = this.pendingUser.rrn;
        if (!rrn || rrn.length !== 7 || isNaN(rrn)) {
          return '';
        }

        const datePart = rrn.slice(0, 6);
        const lastDigit = rrn[6];

        return `${datePart}-${lastDigit}******`;
      },
      set(newValue) {
        const cleanValue = newValue.replace(/[^0-9]/g, '').slice(0, 7);
        this.pendingUser.rrn = cleanValue;
      },
    },

    isDanger업체() {
      if (!this.pendingUser.meta.업체 || this.pendingUser.meta.업체.com_name === "" || this.pendingUser.meta.업체.id === "") {
        this.error.업체 = "업체가 지정되지 않았습니다."
        return true;
      }

      this.error.업체 = ""
      return false
    },

    isDangerJobInput() {
      if (!this.pendingUser.meta.직종) {
        this.error.직종 = '직종을 선택해주세요.'
        return true;
      }

      this.error.직종 = ''
      return false;
    },

    isDangerEquipmentNameInput() {
      if (!this.pendingUser.meta.장비명) {
        this.error.장비명 = '장비명을 선택해주세요.'
        return true;
      }

      this.error.장비명 = ''
      return false;
    },

    isDangerEquipmentSizeInput() {
      if (!this.pendingUser.meta.장비규격) {
        this.error.장비규격 = '규격을 선택해주세요.'
        return true;
      }

      this.error.장비규격 = ''
      return false;
    },
  },
  data() {
    return {
      tabIndex: 0,
      fieldOptions: [],
      직종Options: occupation,
      장비명Options: equipmentName,
      장비규격Options: [],

      popupSearchCompany: false,
      popupRejectJoin: false,
      registerTypeList: registerTypeList,

      originPendingUserString: "", // backup original pending user data
      editMode: false,

      pendingUser: {
        id: 0,
        username: "",
        name: "",
        name_masked: "",
        rrn: "",
        phone: "",
        phone1: "",
        phone2: "",
        phone3: "",
        phone_masked: "",
        email: "",
        email_masked: "",
        isForeigner: false,
        registered_at: "",
        rejected_at: "",
        created_at: "",
        updated_at: "",
        meta: {
          address: {
            home_zip: "",
            home_address_1: "",
            home_address_2: "",
          },
          직종: "",
          직종_직접입력: "",
          field: "",
          건설업기초안전교육: "",
          업체: {
            com_name: "",
            com_number: "",
          },
          장비운전자: false,
          건설기계조종사면허번호: "",
          enc: {
            건설기계조종사면허증사진: "",
          },
          registerType: "",

          장비명: "",
          장비명_직접입력: "",
          장비규격: "",
          장비규격_직접입력: "",
          장비번호: "",
        }
      },
      error: {
        업체: "",
        직종: "",
        장비명: "",
        장비규격: "",
      },
    };
  },
  async created() {
    this.initBreadcrumb()
    await this.loadFieldList()
    await this.loadPendingUser(this.getId)
  },
  // input-icon-validate 클래스를 가진 엘리먼트에 대해 MutationObserver를 이용하여 자식 엘리먼트가 추가될 때마다 display: none 처리
  mounted() {
    this.$nextTick(() => {
      const iconElements = this.$el.querySelectorAll('.input-icon-validate');
      iconElements.forEach(iconElement => {
        iconElement.style.display = 'none';
      });

      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach(node => {
              if (node.classList && node.classList.contains('input-icon-validate')) {
                node.style.display = 'none';
              }
            });
          }
        });
      });

      observer.observe(this.$el, { childList: true, subtree: true });
    });
  },
  methods: {
    initBreadcrumb () {
      this.$store.commit('menu/UPDATE_PAGE_LIST', [{title: 'Home'}, {title: '작업자 관리'}, {title: '회원가입 신청 현황', active: true}])
    },
    // 업체변경 선택
    handleClickSelectCompany(company) {
      this.pendingUser.meta.업체 = company;
    },
    // 현장명 검색
    async loadFieldList() {
      await HttpRequest.get('/api/v1/field/pub')
        .then(response => {
          if (response) {
            this.fieldOptions = response[0].fields.map((data) => {
              return {
                id: data.id,
                field_name: data.field_name,
              };
            });
          }
        }).catch(err => {
          console.log("err", err);
        });
    },
    // 장비명 선택시 규격 옵션 변경
    onEquipmentNameChange(key) {
      // 함수로 호출하여 장비규격 배열 가져오기
      this.장비규격Options = getEquipmentSizeByKey(key);

      console.log('장비규격Options:', this.장비규격Options);

      // 현재 선택된 장비규격이 새로운 옵션 목록에 없으면 초기화
      if (this.장비규격Options.length > 0 && !this.장비규격Options.includes(this.pendingUser.meta.장비규격)) {
        this.pendingUser.meta.장비규격 = '';
      }

      // 값이 없거나 빈 배열일 경우 직접입력 옵션 추가
      if (!this.장비규격Options || this.장비규격Options.length === 0) {
        this.장비규격Options = ['직접입력'];
      } else if (!this.장비규격Options.includes('직접입력')) {
        // 이미 배열이 있고 직접입력이 없으면 추가
        this.장비규격Options.push('직접입력');
      }

      // Vue가 변경을 감지하도록 $nextTick 사용
      this.$nextTick(() => {
        console.log('업데이트된 장비규격Options:', this.장비규격Options);
      });
    },


    onClickTab(tab) {
      this.tabIndex = tab.code;
      this.$router.push({ name: tab.name });
    },
    onClickClose() {
      this.$router.push({ name: 'page-standing-account-list' });
    },
    onClickJoinAccount() {
      if (this.isDanger업체) {
        alert("업체가 지정되지 않았습니다.")
        return
      }
      if (this.isDangerJobInput) {
        alert("직종을 선택해주세요.")
        return
      }
      if (this.isDangerEquipmentNameInput) {
        alert("장비명을 선택해주세요.")
        return
      }
      if (this.isDangerEquipmentSizeInput) {
        alert("규격을 선택해주세요.")
        return
      }

      this.loadJoinAccount(this.getId)
    },
    onClickRejectJoinAccount(reason) {
      this.loadRejectJoinAccount(this.getId, reason)
    },
    onClickCancel() {
      this.pendingUser = JSON.parse(this.originPendingUserString)
      this.fixMissingMetaData()
    },
    onClickSave() {
      if (this.isDanger업체) {
        alert("업체가 지정되지 않았습니다.")
        return
      }
      this.loadEditAccount(this.getId)
    },

    fixMissingMetaData() {
      if (!this.pendingUser.meta) {
        this.pendingUser.meta = {
          address: {
            home_zip: "",
            home_address_1: "",
            home_address_2: "",
          },
          직종: "",
          직종_직접입력: "",
          field: "",
          건설업기초안전교육: "",
          업체: {
            com_name: "",
            com_number: "",
          },
          장비운전자: false,
          건설기계조종사면허번호: "",
          enc: {
            건설기계조종사면허증사진: "",
          },
          registerType: "",

          장비명: "",
          장비명_직접입력: "",
          장비규격: "",
          장비규격_직접입력: "",
          장비번호: "",
        };
        return
      }

      // Set default values for missing fields
      if (this.pendingUser.meta.업체 === undefined) {
        this.pendingUser.meta.업체 = "";
      }
      if (this.pendingUser.meta.address === undefined || Array.isArray(this.pendingUser.meta.address)) {
        this.pendingUser.meta.address = {
          home_zip: "",
          home_address_1: "",
          home_address_2: "",
        };
      }
      if (this.pendingUser.meta.address.home_zip === undefined) {
        this.pendingUser.meta.address.home_zip = "";
      }
      if (this.pendingUser.meta.address.home_address_1 === undefined) {
        this.pendingUser.meta.address.home_address_1 = "";
      }
      if (this.pendingUser.meta.address.home_address_2 === undefined) {
        this.pendingUser.meta.address.home_address_2 = "";
      }
      if (this.pendingUser.meta.직종 === undefined) {
        this.pendingUser.meta.직종 = "";
      }
      if (this.pendingUser.meta.직종_직접입력 === undefined) {
        this.pendingUser.meta.직종_직접입력 = "";
      }
      if (this.pendingUser.meta.건설업기초안전교육 === undefined) {
        this.pendingUser.meta.건설업기초안전교육 = "";
      }
      if (this.pendingUser.meta.건설기계조종사면허번호 === undefined) {
        this.pendingUser.meta.건설기계조종사면허번호 = "";
      }
      if (this.pendingUser.meta.enc.건설기계조종사면허증사진 === undefined) {
        this.pendingUser.meta.enc.건설기계조종사면허증사진 = "";
      }
      if (this.pendingUser.meta.장비운전자 === undefined) {
        this.pendingUser.meta.장비운전자 = false;
      }
      if (this.pendingUser.meta.장비명 === undefined) {
        this.pendingUser.meta.장비명 = "";
      }
      if (this.pendingUser.meta.장비명_직접입력 === undefined) {
        this.pendingUser.meta.장비명_직접입력 = "";
      }
      if (this.pendingUser.meta.장비규격 === undefined) {
        this.pendingUser.meta.장비규격 = "";
      }
      if (this.pendingUser.meta.장비규격_직접입력 === undefined) {
        this.pendingUser.meta.장비규격_직접입력 = "";
      }
      if (this.pendingUser.meta.장비번호 === undefined) {
        this.pendingUser.meta.장비번호 = "";
      }
      // 해당작업을 하지 않으면 사업체명 select 에서 선택된 값이 [object Object]로 나옴
      if (this.pendingUser.meta.field) {
        this.pendingUser.meta.field = this.fieldOptions.find(field => field.id === this.pendingUser.meta.field.id);
      }
      if (this.pendingUser.meta.장비명) {
        this.onEquipmentNameChange(this.pendingUser.meta.장비명)
      }
    },

    async loadPendingUser(userId) {
      try {
        const response = await HttpRequest.get(`/api/v1/user/pending/${userId}`);

        if (response) {

          this.pendingUser.id = response.id;
          this.pendingUser.username = response.username;
          this.pendingUser.name = response.name? response.name : "";
          this.pendingUser.name_masked = response.name_masked? response.name_masked : "";
          this.pendingUser.rrn = response.rrn? response.rrn : "";
          this.pendingUser.phone = response.phone? response.phone : "";

          // Split phone number into parts
          if (response.phone && response.phone.length === 11) {
            this.pendingUser.phone1 = response.phone.substring(0, 3);
            this.pendingUser.phone2 = response.phone.substring(3, 7);
            this.pendingUser.phone3 = response.phone.substring(7, 11);
          }

          this.pendingUser.phone_masked = response.phone_masked? response.phone_masked : "";
          this.pendingUser.email = response.email? response.email: "";
          this.pendingUser.email_masked = response.email_masked? response.email_masked : "";
          this.pendingUser.isForeigner = response.is_foreigner === undefined? false : response.is_foreigner;
          this.pendingUser.registered_at = response.registered_at;
          this.pendingUser.rejected_at = response.rejected_at;
          this.pendingUser.created_at = response.created_at;
          this.pendingUser.updated_at = response.updated_at;
          this.pendingUser.meta = response.meta;

          this.fixMissingMetaData()
          this.originPendingUserString = JSON.stringify(this.pendingUser);

          console.log("this.pendingUser", this.pendingUser);
        } else {
          console.error("Response or response.data is undefined");
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
    },
    async loadJoinAccount(userId) {
      let result = false
      await HttpRequest.post(`/api/v1/user/pending/${userId}/approve`,
        {
          // companyId: this.pendingUser.meta.업체.id,
        }
      )
        .then(response => {
          if (response) {
            result = true
            console.log("response", response)
          }
        }).catch(err => {
          if (err.response) {
            console.log("err", err)
            if (err.response.data) {
              console.log("errResponse", err.response.data)
            }
          }
        })

      if (result) {
        this.customAlert("회원가입이 승인되었습니다.")
      }
    },
    async loadRejectJoinAccount(userId, reason) {
      await HttpRequest.post(`/api/v1/user/pending/${userId}/reject`,
        {
          reason: reason,
        }
      )
        .then(response => {
          if (response) {
            console.log("response", response)
            this.onClickClose()
          }
        }).catch(err => {
          if (err.response) {
            console.log("err", err)
            if (err.response.data) {
              console.log("errResponse", err.response.data)
            }
          }
        })
    },
    async loadEditAccount(userId) {
      let result = false
      await HttpRequest.post(`/api/v1/user/pending/${userId}`,
        {
          email: this.pendingUser.email,
          meta: JSON.stringify(this.pendingUser.meta),
        }
      )
        .then(response => {
          if (response) {
            console.log("response", response)
            result = true
          }
        }).catch(err => {
          if (err.response) {
            console.log("err", err)
            if (err.response.data) {
              console.log("errResponse", err.response.data)
            }
          }
        })

      if (result) {
        await this.loadPendingUser(this.getId)
      }
    },

    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "가입승인",
          message: msg,
          cancelBtn: "확인",
          cancelFunction: () => this.onClickClose(),
        },
      });
      window.dispatchEvent(customAlert);
    },
  },
  watch: {
    pendingUser: {
      deep: true,
      handler(newValue) {
        if (this.originPendingUserString !== JSON.stringify(newValue)) {
          this.editMode = true
        }
        else {
          this.editMode = false
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    background-color: #f5f5f5;
    font-weight: 700;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-body {
    background-color: #ffffff;
    & > div { border-bottom: 1px solid #e0e0e0; }
    & > div:hover { background-color: #f5f5f5; color: #000; font-weight: bold }
    & > div.active { background-color: #7E72F299; color: #fff }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(10, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }



  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}


.align-center {
  align-items: center;
}
.success-color {
  color: #28C76F;
}
.alert-color {
  color: #EA5455;
}
.input-button {
  height: 37.5px
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem; /* Adjust the gap as needed */

  font-weight: 500;
  font-size: 14px;
}

.grid-item {
  align-self: start;
  grid-column: span 2;
}

@media (min-width: 768px) {
  .grid-item {
    align-self: start;
    grid-column: span 1;
  }
}
</style>
